import { useContext } from "react";
import { DependenciesContext } from "../providers/Dependencies";
import { Daphne } from "@syadem/daphne-js";

export function useDaphne(): Daphne {
  const dependencies = useContext(DependenciesContext);
  if (!dependencies) {
    throw new Error("Dependencies container is null, did you forget to pass it to the provider?");
  } else {
    return dependencies.daphne;
  }
}
